export default "__VITE_PUBLIC_ASSET__8ba38d48__"